import(/* webpackMode: "eager" */ "/vercel/path0/apps/famvia-dash/src/ui/scrollable-area/index.tsx")